import {FieldTypeKind} from '../../enum/field.type.kind';
import {IEntity} from './core.base.entity.interface';
import {Column} from './core.entity.column';
import {PrimaryKey} from './core.entity.primary.key';

export class Entity implements IEntity {

    [key: string]: any;

    @PrimaryKey()
    @Column(FieldTypeKind.GUID)
    public id: string;

    @Column(FieldTypeKind.GUID)
    public createdBy: string;

    @Column(FieldTypeKind.DATE)
    public createdAt: Date;

    @Column(FieldTypeKind.GUID)
    public updatedBy: string;

    @Column(FieldTypeKind.DATE)
    public updatedAt: Date;

    @Column(FieldTypeKind.BOOLEAN)
    public active: boolean;
}